import React from "react"
import Container from "@ecom/ui/components/Container"
import * as styles from "./timer.module.scss"
import GiftImg from "./GiftImg"
import { CountDown } from "../../HeaderAb/CountDown"

export const Timer = ({ countDownTime }: { countDownTime?: number }) => (
  <div className={styles.card}>
    <Container>
      <div className={styles.innerWrapper}>
        <GiftImg alt="подарок" className={styles.img} />
        <div className={styles.textBlock}>
          <p className={styles.title}>Успейте получить подарок!</p>
          <p className={styles.description}>«Халва.Десятка» на месяц за 0₽</p>
        </div>

        <CountDown
          nameCountDown="countDownDateForm"
          backgroundColor="white"
          countDownTime={countDownTime}
        />
      </div>
    </Container>
  </div>
)
